const COMMENT = {
  ACTIONS: {
    LIKE: 'like',
    DISLIKE: 'dislike',
    REMOVE: 'remove',
  },
  COUNT_FORMAT: {
    COMMENTS: 'comentários',
    NO_COMMENTS: '0 comentários',
    ONE_COMMENT: '1 comentário',
  },
  DELETE_CONFIRMATION: 'Deseja mesmo excluir esse comentário?',
  DROPDOWN: {
    REPORT: 'Denunciar comentário',
    RECOMMEND: 'Sugerir como review',
    DELETE: 'Excluir comentário',
  },
  FIXED: 'Comentário fixado',
  NO_COMMENTS_YET: 'Ainda não há comentários',
  NOTIFICATION_LABEL: 'Receber notificações de novos comentários',
  TITLE: 'Comentário',
  SORT_LABELS: {
    BY_OLDER: 'Mais antigos',
    BY_LATEST: 'Mais recentes',
    BY_RELEVANCE: 'Mais relevantes',
  },
  SORT_VALUES: {
    OLDEST: 'oldest',
    LATEST: 'latest',
    RELEVANCE: 'relevance',
  },
  SORT_BY: 'Ordenar por',
  STATUSES: {
    WAITING: 'WAITING',
    PROCESSING: 'PROCESSING',
    APPROVED: 'APPROVED',
    REMOVED_BY_ADMIN: 'REMOVED_BY_ADMIN',
    REMOVED_BY_USER: 'REMOVED_BY_USER',
    REMOVED_FOR_ALL: 'REMOVED_FOR_ALL',
    PARTIALLY_REMOVED: 'REMOVED_PARCIAL',
    USELESS: 'USELESS',
  },
};

export default COMMENT;
